import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  StyleSheet,
  View,
  Text,
  ScrollView,
} from './components/base_components';
import { BusyOverlay, useBusy } from './components/busy_component';
import TextButton from './components/buttons/text_button';

import UserStore from './stores/user_store';

const styles = StyleSheet.create({
  logoutScreen: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'transparent',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
  },
  scroller: { flex: 1, alignSelf: 'stretch', flexDirection: 'column' },
  scrollInner: {
    paddingLeft: '3em',
    paddingRight: '3em',
    paddingTop: '1em',
    paddingBottom: '5em',
    alignSelf: 'stretch',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    overflowY: 'scroll',
  },
  line: { alignSelf: 'stretch', height: '1px', backgroundColor: 'black' },
  headerText: {
    marginTop: '1em',
    color: '#222',
    fontSize: '1.2em',
    fontWeight: 'bold',
  },
  button: { marginTop: '1em', height: '2em' },
});

export default function LogoutScreen() {
  const [is_busy, setBusy, clearBusy] = useBusy();
  const navigate = useNavigate();

  React.useEffect(() => {
    setTimeout(_onLogoutPress, 100);
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function _onLogoutPress() {
    if (setBusy()) {
      UserStore.logout((err: any) => {
        clearBusy();
        if (err && err !== 403) {
          window.alert('Logout failed');
        } else {
          navigate('/');
        }
      });
    }
  }
  return (
    <View style={styles.logoutScreen}>
      <ScrollView
        style={styles.scroller}
        contentContainerStyle={styles.scrollInner}
      >
        <Text style={styles.headerText}>Maxlo</Text>
        <View style={styles.line} />
        <Text style={styles.headerText}>Logout</Text>
        <TextButton
          style={styles.button}
          text='Logout'
          onPress={_onLogoutPress}
        />
      </ScrollView>
      <BusyOverlay isBusy={is_busy} />
    </View>
  );
}
